import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=39808978&scoped=true"
import script from "./PopupDialog.vue?vue&type=script&lang=js"
export * from "./PopupDialog.vue?vue&type=script&lang=js"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=39808978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39808978",
  null
  
)

export default component.exports